
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(98(24|93)|2968|6442|7393|7808|8524|8605)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
